export type CoachmarkId = 'door_walk' | 'joystick_move' | 'level_up' | 'hazard';

const KEY = (id: CoachmarkId) => `cradle7.coach.${id}`;
const ALL_IDS: CoachmarkId[] = ['door_walk', 'joystick_move', 'level_up', 'hazard'];
const TUTORIAL_KEY = 'cradle7.tutorialSeen';

export function coachmarkSeen(id: CoachmarkId): boolean {
  try { return typeof window !== 'undefined' && window.localStorage.getItem(KEY(id)) === '1'; }
  catch { return false; }
}

export function markCoachmarkSeen(id: CoachmarkId): void {
  try { if (typeof window !== 'undefined') window.localStorage.setItem(KEY(id), '1'); }
  catch { /* ignore (private mode / quota) */ }
}

/** Clears all coachmark flags + the first-run Tutorial flag so onboarding replays. */
export function resetOnboarding(): void {
  try {
    if (typeof window === 'undefined') return;
    for (const id of ALL_IDS) window.localStorage.removeItem(KEY(id));
    window.localStorage.removeItem(TUTORIAL_KEY);
  } catch { /* ignore */ }
}
